import { NavLink } from "react-router"

import { Button } from "@/components/ui/button"

export default function DigesterHeader() {
  return (
    <div className="mb-3">
      <NavLink to={"/dashboards/Digesters"} end>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-r-none ${isActive && "text-accent-foreground"}`}
          >
            Feeding Detail
          </Button>
        )}
      </NavLink>
      <NavLink to={"/dashboards/Digesters/metrics"}>
        {({ isActive }) => (
          <Button
            variant="outline"
            className={`rounded-l-none border-l-0 ${isActive && "text-accent-foreground"}`}
          >
            Digester Metrics
          </Button>
        )}
      </NavLink>
    </div>
  )
}
